import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-products-list-sidebar',
  templateUrl: './products-list-sidebar.component.html',
  styleUrls: ['./products-list-sidebar.component.css']
})
export class ProductsListSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
